import React, { Component } from 'react';
import compose from 'recompose/compose';
import { connect } from 'react-redux';
import {
  Edit,
  TextInput,
  SimpleForm,
  ReferenceInput,
  SelectInput,
  DateInput,
  BooleanInput,
  REDUX_FORM_NAME,
} from 'react-admin';
import { formValueSelector } from 'redux-form';
import { withStyles } from '@material-ui/core/styles';

import Title from './Title';

const styles = {
  root: {
    marginTop: '24px',
  },
};

const customerRenderer = record => `${record.first_name} ${record.last_name}`;

const _tz_offset = new Date().getTimezoneOffset() / 60;
const dateParser = v => {
  const regexp = /(\d{4})-(\d{2})-(\d{2})/;
  var match = regexp.exec(v);
  if (match === null) return;

  var year = match[1];
  var month = match[2];
  var day = match[3];

  if (_tz_offset < 0) {
    // negative offset means our picked UTC date got converted to previous day
    var date = new Date(v);
    date.setDate(date.getDate() + 1);
    match = regexp.exec(date.toISOString());
    year = match[1];
    month = match[2];
    day = match[3];
  }
  const d = [year, month, day].join('-');
  return d;
};

class EditForm extends Component {
  handleChangeFamilyCar = (e, checked) => {
    this.setState({ isFamilyCar: checked });
  };

  handleChangeCarBrand = (e, data) => {
    this.setState({ carBrandID: data });
  };

  state = {
    carBrandID: '',
  };

  render() {
    const { classes, isFamilyCar, carBrandID, dispatch, ...props } = this.props;
    return (
      <Edit title={<Title />} {...props}>
        <SimpleForm>
          <ReferenceInput label="Customer" source="user_id" reference="customers" perPage={-1}>
            <SelectInput optionText={customerRenderer} />
          </ReferenceInput>
          <BooleanInput
            source="is_family_car"
            label="Family Car"
            // input={{ name: 'is_family_car', checked: isFamilyCar, onChange: this.handleChangeFamilyCar }}
            classes={{ root: classes.root }}
            onChange={this.handleChangeFamilyCar}
          />
          {isFamilyCar && <TextInput source="relationship" />}
          {isFamilyCar && <TextInput source="relationship_name" label="Full Name" />}
          {isFamilyCar && <TextInput source="relationship_mobile" label="Mobile Number" />}
          <ReferenceInput
            label="Car Brand"
            source="car_brand_id"
            reference="brands"
            onChange={this.handleChangeCarBrand}
            perPage={-1}
          >
            <SelectInput optionText="name" />
          </ReferenceInput>
          <ReferenceInput
            label="Car Model"
            source="car_model_id"
            reference="models"
            filter={{ car_brand_id: carBrandID }}
            perPage={-1}
          >
            <SelectInput optionText="name" />
          </ReferenceInput>
          <TextInput source="reg_no" />
          {!isFamilyCar && <DateInput parse={dateParser} source="reg_date" />}
          {!isFamilyCar && <TextInput source="chasis_no" label="Chassis no" />}
          {!isFamilyCar && (
            <ReferenceInput
              label="Sales Consultant"
              source="sales_advisor_id"
              reference="sales_advisors"
              filter={{ car_brand_id: carBrandID }}
              perPage={-1}
            >
              <SelectInput optionText="full_name" />
            </ReferenceInput>
          )}
          {!isFamilyCar && (
            <ReferenceInput
              label="Service Consultant"
              source="service_consultant_id"
              reference="service_consultants"
              filter={{ car_brand_id: carBrandID }}
              perPage={-1}
            >
              <SelectInput optionText="full_name" />
            </ReferenceInput>
          )}
          <DateInput parse={dateParser} source="last_service_date" />
        </SimpleForm>
      </Edit>
    );
  }
}

const formSelector = formValueSelector(REDUX_FORM_NAME);
const mapStateToProps = state => {
  return {
    isFamilyCar: formSelector(state, 'is_family_car'),
    carBrandID: formSelector(state, 'car_brand_id'),
  };
};

export default compose(
  withStyles(styles),
  connect(mapStateToProps),
)(EditForm);



// WEBPACK FOOTER //
// ./src/containers/CustomerCar/EditForm.js